import { writable } from 'svelte/store';

export const activeNav = writable<string>('Election Updates');
export const utm_medium = writable<string>('spaces_maosp');
